export function getStoreType() {
  var qs = new URLSearchParams(location.search);
  var storeType = qs.get('store_type') || qs.get('store');
  return storeType ? storeType : '';
}
